jQuery(document).ready(function () {
    if ($('.realisationsmini').length > 0) {
        var itemToDisplay = 3;
        function defineCardToDisplay() {
            $('.realisationsmini_lastNews-link:lt(' + itemToDisplay + ')').show();
        }
        defineCardToDisplay();

    }
});
